/**
 * Product Status Badge Component
 * Displays product status with visual indicators
 */

import './ProductStatusBadge.css';

interface ProductStatusBadgeProps {
  status: 'publish' | 'draft' | 'archived';
  stockQuantity?: number;
}

const ProductStatusBadge = ({ status, stockQuantity }: ProductStatusBadgeProps) => {
  const getStatusLabel = () => {
    if (status === 'archived') return '已封存';
    if (stockQuantity === 0) return '缺貨';
    if (stockQuantity !== undefined && stockQuantity < 10) return '庫存不足';
    return status === 'publish' ? '已發布' : '草稿';
  };

  const getStatusClass = () => {
    if (status === 'archived') return 'product-status-badge--archived';
    if (stockQuantity === 0) return 'product-status-badge--out-of-stock';
    if (stockQuantity !== undefined && stockQuantity < 10) return 'product-status-badge--low-stock';
    return status === 'publish' ? 'product-status-badge--published' : 'product-status-badge--draft';
  };

  return (
    <span className={`product-status-badge ${getStatusClass()}`}>
      {getStatusLabel()}
    </span>
  );
};

export default ProductStatusBadge;
